import { CommandBarButton, DirectionalHint, FontIcon, IColumn, IOverflowSetItemProps, OverflowSet, SelectionMode, Stack, TooltipHost } from "@fluentui/react";
import { IIpercActividad } from "../../../Interfaces/IIpercBase";
import { IPersonaCheckList } from "../CheckList/PersonaCheckList";
import COLORES from "../../../utils/theme/colores";
import themeBase from "../../../utils/theme/themeBase";
import { UsePersonaIperc } from "./UsePersonaIperc";
import { TableComponent } from "../../../components/Table/TableComponent";
import { IButtonGroup } from "../../../Interfaces/filter";
import HelpersIpercBase from "../../../utils/helpers/HelpersIpercBase";
import DefinirNuevoIpercBase from "../../iperc/ipercBase/DefinirNuevoIpercBase";
import DefaultSelect from "../../../components/generic/defaultSelect";
import { useBoolean } from "@fluentui/react-hooks";
import { IItemIPERC } from "../../../Interfaces/IIPERC";
import { useState } from "react";

export const PersonaIperc=(props:IPersonaCheckList)=>{
    const {filter,setFilter,items,loading,pagination,handleResetUpdate} = UsePersonaIperc(props)
    const [isOpenNuevoPeligro, { setTrue: openNuevoPeligro, setFalse: dismissNuevoPeligro }] = useBoolean(false);
    const [itemSeleccionadoValue, setItemSeleccionadoValue] = useState<IItemIPERC>();


    const buttonLeft: IButtonGroup[] = [
        {
             onClick: () => {
               handleResetUpdate();
             },
             text: "Actualizar",
       },
   ];

    const _onRenderItemColumEstado = (item: any,) => {
        let resul = <>{item.created}</>
        switch (item.created) {
            case "Rechazado":
                resul =
                    <Stack verticalAlign="space-around">
                        <TooltipHost content='Rechazado' >
                            <FontIcon iconName="IncidentTriangle" style={{ color: themeBase.colorsBaseMessaging.SevereWarningIcon }} />
                        </TooltipHost>
                    </Stack>
                break
            case "Verificado":
                resul =
                    <Stack verticalAlign="space-around" horizontalAlign="center">
                        <TooltipHost content='Verificado' >
                            <FontIcon iconName="SkypeCircleCheck" style={{ color: COLORES.Messaging.SuccessIcon }} />
                        </TooltipHost>
                    </Stack>
                break
            case "Pendiente":
                resul =
                    <Stack verticalAlign="space-around" horizontalAlign="center">
                        <TooltipHost content='Pendiente' >
                            <FontIcon iconName="SkypeCircleClock" style={{ color: COLORES.Messaging.SevereWarningIcon }} />
                        </TooltipHost>
                    </Stack>
                break
            case "":
                resul =
                    <Stack verticalAlign="space-around" horizontalAlign="center">
                        <TooltipHost content='Pendiente' >
                            <FontIcon iconName="SkypeCircleClock" style={{ color: COLORES.Messaging.SevereWarningIcon }} />
                        </TooltipHost>
                    </Stack>
                break
            default:
                resul =
                    <Stack verticalAlign="space-around" horizontalAlign="center">
                        <TooltipHost content='-' >
                            <FontIcon iconName="SkypeCircleClock" style={{ color: COLORES.Messaging.SevereWarningIcon }} />
                            {/* <FontIcon iconName="StatusCircleQuestionMark" style={{ color: COLORES.Messaging.ErrorBlockIcon }} /> */}
                        </TooltipHost>
                    </Stack>
                break;
        }
        return <div style={{width:'50px'}}>
        {resul}
        </div>
    }
    const onRenderOverflowButton = (overflowItems: any[] | undefined): JSX.Element => {
        return (
            <TooltipHost content="Opciones" directionalHint={DirectionalHint.rightCenter}>
                <CommandBarButton
                    aria-label="More items"
                    menuIconProps={{ iconName: 'MoreVertical' }}
                    menuProps={{ items: overflowItems! }}
                    styles={{ root: { background: "none"} }}
                />
            </TooltipHost>
        );
    };
    
    const onRenderItem = (item: IOverflowSetItemProps): JSX.Element => {
        return (
            <TooltipHost content={item.title} directionalHint={DirectionalHint.leftCenter}>
                <CommandBarButton
                    aria-label={item.name}
                    iconProps={{ iconName: item.icon }}
                    onClick={item.onClick}
                    styles={{ root: { background: "none" } }}
                />
            </TooltipHost>
        );
    };
    const _columns:IColumn[]= [
        {
            key: 'nombre',
            name: 'Nombre',
            fieldName: 'nombre',
            minWidth: 100,
          maxWidth: 300,     
          isResizable: true,   
          isCollapsible: true,     
          isPadded: true, 
          onRender: (item: IIpercActividad) => (
            <Stack verticalAlign="space-around">
                <p style={{ margin: 0, fontSize: '12px' }}>{item.nombre}</p>
                <span style={{ marginTop: 2, fontSize: '11px' }}>
                <FontIcon iconName="Calendar" style={{
                            color: COLORES.Bases.primary,
                            marginRight: 4
                }} />
                {item.created.substring(0, 10)}
               <FontIcon iconName="HourGlass" style={{color: themeBase.colorsBaseMessaging.ErrorBlockIcon,
               marginLeft: 4,}} />
                {item.created.substring(10, item.created.length)}
                </span>
            </Stack>
          )
        },
        {
            key: 'estado',
            name: 'Estado',
            fieldName: 'estado', 
            onRender: _onRenderItemColumEstado,
            minWidth: 10,
        maxWidth: 30,
        isPadded: true,
        isResizable: true,
        isCollapsible: true,
        },
        {
            key: 'value',
            name: 'Opciones',
            fieldName: 'value',
            minWidth: 10,
            maxWidth: 50,
            isResizable: true,
            onRender: (item: IIpercActividad) => (
                <Stack verticalAlign="space-around" horizontalAlign="center" style={{width:'10%'}}>
                    <OverflowSet
                        items={[]}
                        overflowItems={[
                            {
                                key: 'item1',
                                name: 'Nuevo Peligro',
                                iconProps: { iconName: "add" },
                                onClick: () => { openNuevoPeligro() }
                            },
                            {
                                key: 'item3',
                                name: 'Editar',
                                iconProps: { iconName: "edit" }
                            }
                        ]}
                        onRenderOverflowButton={onRenderOverflowButton}
                        onRenderItem={onRenderItem}
                    />
                </Stack>
            )
        },
        
    ];
    const visualizar=()=>{
        return (
            <>
            {itemSeleccionadoValue ? (<>
                <DefinirNuevoIpercBase
            actividadId={itemSeleccionadoValue?.actividadId!}
            isOpenNuevoPeligro={isOpenNuevoPeligro}
            onDismissNuevoPeligro={dismissNuevoPeligro}
            />
            </>):(<div style={{width:'700px',maxHeight: "600px", overflowY: "auto"}}>
                <DefaultSelect iconName="Dialpad" />
            </div>)}
            </>
        )
    }
   return (
    <div style={{display:'flex'}}>
    <TableComponent data={items} selection={SelectionMode.single} visualizar={visualizar} setItemSeleccionadoValue={setItemSeleccionadoValue} tableWidth={"40%"} leftButtons={buttonLeft} header={false} column={_columns} compact={true} paginacion={pagination} isLoading={loading}/>
    
    </div>
   )
}